export default "__VITE_ASSET__ae144650__"